export default "__VITE_ASSET__y8Nr6nPs__"